export const getShortPlayerName = (
  entry,
  onlyFirst = false,
  onlyLast = false,
) => {
  const shortFirst = entry?.shortFirstName || "";
  const shortLast = entry?.shortLastName || "";
  const knownName = entry?.knownName || "";
  const matchName = entry?.matchName || "";

  // Ensure we always have fallback logic
  const hasValidName = knownName || matchName || (shortFirst && shortLast);

  // Return only the first name
  if (onlyFirst) {
    return shortFirst || knownName || matchName || "";
  }

  // Return only the last name
  if (onlyLast) {
    if (knownName.includes(shortLast) || matchName.includes(shortLast)) {
      return shortLast; // Safely return shortLast without redundancy
    }
    return shortLast || knownName || matchName || "";
  }

  // Default: Full name (avoid duplication)
  if (knownName) {
    return knownName;
  }
  if (matchName) {
    return matchName;
  }
  if (shortFirst && shortLast) {
    return `${shortFirst} ${shortLast}`;
  }

  return ""; // Fallback if no name is valid
};


export const getPlayerShorLastName = (
  entry,
  onlyFirst = false,
  onlyLast = false,
) => {
  const shortFirst = entry?.shortFirstName || "";
  const shortLast = entry?.shortLastName || "";
  const knownName = entry?.knownName || "";
  const matchName = entry?.matchName || "";

  // Ensure we always have fallback logic
  const hasValidName = knownName || matchName || (shortFirst && shortLast);

  // Return only the first name
  if (onlyFirst) {
    return shortFirst || knownName || matchName || "";
  }

  // Return only the last name
  if (onlyLast) {
    if (knownName.includes(shortLast) || matchName.includes(shortLast)) {
      return shortLast; // Safely return shortLast without redundancy
    }
    return shortLast || knownName || matchName || "";
  }

  if (shortLast) {
    return shortLast;
  }
  // Default: Full name (avoid duplication)
  if (knownName) {
    return knownName;
  }
  if (matchName) {
    return matchName;
  }
  if (shortFirst && shortLast) {
    return `${shortFirst} ${shortLast}`;
  }

  return ""; // Fallback if no name is valid
};
